/**
 * The seeded user directory.
 *
 * A clean installation holds exactly one account — the owner, בן פרץ — and
 * every other user is added from the management screens once the unit is on
 * the system. No demo accounts are written: the directory the operator opens
 * is the directory they built.
 *
 * The OTP step is still simulated, so signing in needs nothing but the phone
 * number and the code shown on screen.
 */
import type { User } from '../types/user';

const SEEDED_AT = '2026-01-01T08:00:00.000Z';

/** The owner account — unrestricted, and the only one seeded with a PIN. */
export const SUPER_ADMIN_ID = 'usr-super-admin-01';

export const MOCK_USERS: readonly User[] = [
  {
    id: SUPER_ADMIN_ID,
    phone: '0524063968',
    fullName: 'בן פרץ',
    // The owner's real military personal number — the same one their record on
    // the company roster carries (`src/core/seed-soldiers.ts`).
    personalNumber: '7533454',
    role: 'super_admin',
    company: 'פלוגת שינוע 99',
    platoon: 'מפקדה',
    status: 'active',
    isApproved: true,
    createdAt: SEEDED_AT,
  },
];

/** Phone numbers surfaced as a testing hint on the sign-in screen. */
export const MOCK_PHONES: readonly string[] = MOCK_USERS.map((user) => user.phone);

/** Quick-unlock code provisioned for the super-admin on first run. */
export const DEFAULT_SUPER_ADMIN_PIN = '9999';

/**
 * Seeded accounts that start life with a local PIN already set, so the first
 * unlock needs no setup step. Everyone else still chooses their own code.
 */
export const MOCK_DEFAULT_PINS: Readonly<Record<string, string>> = {
  [SUPER_ADMIN_ID]: DEFAULT_SUPER_ADMIN_PIN,
};
